package waldo.sankan.lineamunicipalkmp.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.js.Date

@Composable
fun FilterDropdown(
    label: String,
    selectedValue: String?,
    options: List<String>,
    onValueChanged: (String?) -> Unit,
    isNullable: Boolean = true,
    optionDisplayNames: Map<String, String>? = null
) {
    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px) } }) {
        Label(attrs = { style { fontWeight("bold"); color(Color("#333333")); fontSize(14.px) } }) { Text(label) }
        Select(attrs = {
            style {
                padding(6.px, 10.px); fontSize(14.px); borderRadius(6.px); backgroundColor(Color.white);
                color(Color.black); border(1.px, LineStyle.Solid, Color("#cccccc"))
            }
            onChange { event -> onValueChanged(if (event.target.value == "TODOS" && isNullable) null else event.target.value) }
        }) {
            if (isNullable) {
                Option(value = "TODOS", attrs = { if (selectedValue == null) selected() }) { Text("Todos") }
            }
            options.forEach { optionValue ->
                Option(value = optionValue, attrs = { if (optionValue == selectedValue) selected() }) {
                    Text(optionDisplayNames?.get(optionValue) ?: optionValue)
                }
            }
        }
    }
}